"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgorithmEditModal = void 0;
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var styles = __importStar(require("./AlgorithmEditModal.css"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var TwoPanelSettingsModal_1 = require("../TwoPanelSettingsModal");
var AlgorithmLevelsConfiguration_1 = require("./AlgorithmLevelsConfiguration");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var PageStatusIcon_1 = require("@CommonFrontend/Project/PageStatusIcon");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var StringManipulater_1 = require("Utils/StringManipulater");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
function AlgorithmEditModal(_a) {
    var _this = this;
    var closeModal = _a.closeModal, onApply = _a.onApply, algorithm = _a.algorithm, pagesMonitored = _a.pagesMonitored, isNew = _a.isNew;
    var modalService = (0, inversify_react_1.useInjection)("modal");
    var notifyUser = (0, inversify_react_1.useInjection)("notifyUser");
    var _b = __read((0, react_1.useState)(function () { return (0, cloneDeep_1.default)(algorithm); }), 2), localState = _b[0], setLocalState = _b[1];
    var onApplyClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var hasAlgorithmConfigChanges, okToApply;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    hasAlgorithmConfigChanges = !(0, isEqual_1.default)(localState.levelsConfiguration, algorithm.levelsConfiguration);
                    if (!(!isNew && pagesMonitored && hasAlgorithmConfigChanges)) return [3, 2];
                    return [4, modalService.showConfirmModal({
                            title: "Apply Changes?",
                            explainer: "This will update the engagement algorithm for ".concat(pagesMonitored.total, " pages. The more pages the longer it will take to recalculate engagement levels."),
                            confirmLabel: "Apply",
                            isEscapable: true,
                        })];
                case 1:
                    okToApply = _a.sent();
                    if (!okToApply)
                        return [2, false];
                    notifyUser.success("Algorithm applied. It may take some time for your pages' engagement levels to update.");
                    _a.label = 2;
                case 2: return [4, onApply(localState)];
                case 3:
                    _a.sent();
                    return [2, true];
            }
        });
    }); };
    var onAlgorithmChange = function (updatedAlgorithm) {
        setLocalState(updatedAlgorithm);
    };
    return (react_1.default.createElement(TwoPanelSettingsModal_1.TwoPanelSettingsModal, { itemNoun: "engagement algorithm", isNew: isNew, onApply: onApplyClick, onClose: closeModal, hasUnsavedChanges: function () { return !(0, isEqual_1.default)(localState, algorithm); }, hasValidInputs: function () { return true; }, left: react_1.default.createElement(LeftPanel, { algorithm: localState, onAlgorithmChange: onAlgorithmChange, pagesMonitored: pagesMonitored }), right: react_1.default.createElement(AlgorithmLevelsConfiguration_1.AlgorithmLevelsConfiguration, { algorithm: localState, onChange: onAlgorithmChange }) }));
}
exports.AlgorithmEditModal = AlgorithmEditModal;
var LeftPanel = function (_a) {
    var algorithm = _a.algorithm, onAlgorithmChange = _a.onAlgorithmChange, pagesMonitored = _a.pagesMonitored;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.leftPanelWrapper, justify: "spaceBetween" },
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l" },
            react_1.default.createElement(kaleidoscope_1.TextInput, { label: "Name", placeholder: "Proposals", value: algorithm.name, onChange: function (value) { return onAlgorithmChange(__assign(__assign({}, algorithm), { name: value })); }, maxLength: 32 }),
            react_1.default.createElement(kaleidoscope_1.TextInput, { multiline: true, label: "Description", value: algorithm.description, onChange: function (value) { return onAlgorithmChange(__assign(__assign({}, algorithm), { description: value })); }, maxLength: 256 }),
            react_1.default.createElement(kaleidoscope_1.Text, { element: "div", size: "s" },
                "Engagement algorithms allow you to define what engagement means to you.",
                " ",
                react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/824-engagement-algorithm" }, "Learn more"))),
        pagesMonitored && (react_1.default.createElement(kaleidoscope_1.Card, { className: styles.monitoringInfoCard },
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs" },
                react_1.default.createElement(MonitoringLine, { icon: react_1.default.createElement(icons_1.Engagement, { color: "default" }), text: "Assigned to ".concat((0, StringManipulater_1.pluralise)(pagesMonitored.total, "page")), endElement: react_1.default.createElement(MonitoringHelpPopover, null) }),
                react_1.default.createElement("div", { className: styles.monitoringInfoCardDivider }),
                react_1.default.createElement(MonitoringLine, { icon: react_1.default.createElement(PageStatusIcon_1.PageStatusIcon, { status: Types_1.ProjectStatus.Live }), text: "Monitoring ".concat((0, StringManipulater_1.pluralise)(pagesMonitored.live, "live page")) }))))));
};
var MonitoringHelpPopover = function () {
    return (react_1.default.createElement(kaleidoscope_1.Popover, { button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({ icon: react_1.default.createElement(icons_1.InformationCircle, { size: icons_1.IconSize.Small }), size: kaleidoscope_1.ButtonSize.Small }, buttonProps))); }, position: kaleidoscope_1.PopoverPosition.Top, size: kaleidoscope_2.PopoverSize.Small, caret: true, autoStack: true },
        react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", gap: "xs" },
            react_1.default.createElement(kaleidoscope_1.Text, { size: "m", strong: true }, "Assignment and monitoring"),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s", align: "center" }, "An algorithm can be assigned to any page, but only live pages are actively monitored."),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s" },
                react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/824-engagement-algorithm#Monitor" }, "Learn more about monitoring")))));
};
var MonitoringLine = function (_a) {
    var icon = _a.icon, text = _a.text, endElement = _a.endElement;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "spaceBetween" },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "xs" },
            icon,
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, text)),
        endElement));
};
